// extracted by mini-css-extract-plugin
export default {"zoomModal":"f5-z","image":"g5-z","button":"h5-z","isOverlayShown":"i5-z"};